export const combinePages = <T>(pages: { data: T[] }[] = []) => {
  return pages.reduce((acc, el) => [...acc, ...(el.data || [])], [] as T[]) || [];
};
